import React, { Component, Fragment, RefObject, createRef } from 'react'
import { MDXProvider } from '@mdx-js/react'
import { Link } from 'gatsby'

import Header from './Header/Index'
import Footer from './Footer'

import MainBackground from './MainBackground/Index'

import CookCons from './CookieConsent'
import {
  gdprEmbeddedCheck,
  gdprCookieManagementPage,
} from './CookieConsent/embedded'

const shortcodes = { Link }

export class Layout extends Component<Props> {
  target: RefObject<HTMLDivElement> = createRef()

  // Cookie consent embedded medias
  componentDidMount() {
    gdprEmbeddedCheck()
    if (this.props.location.pathname === '/politique-de-cookies/') {
      gdprCookieManagementPage()
    }
  }

  render() {
    return (
      <div className="font-sans leading-normal tracking-normal">
        <Header {...{ location: this.props.location }} />
        <div className="container w-full mx-auto pt-32 text-slate-300">
          <MDXProvider components={shortcodes}>
            {this.props.children}
          </MDXProvider>
        </div>
        <Footer />
        <MainBackground />
        <CookCons />
      </div>
    )
  }
}

export default Layout
